export default __webpack_public_path__ + "static/media/cold-sterilant.57e9712f.jpg";